import './styles/ViewPolls.scss';
import { AppContext, ExAppContext } from '../../Context';
import { ViewPolls_PageMap, ViewPolls_filterMode, ViewPolls_createEditPollMode } from '../../assets/keyMap';
import { Fragment, useState, useEffect, useContext, useRef } from 'react';
import { Camera } from '@capacitor/camera';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
import { useLocation } from 'react-router';
import DateTimePicker from '../../components/DateTimePicker';
import SelectionChecker from '../../components/SelectionChecker';
import ImagePreviewer from '../../components/ImagePreviewer';

//classes
import Poll from '../../exClasses/poll';
// import SelectionList from '../../classes/selectionList';
import CommitteeType from '../../exClasses/committeeType';
import MemberUser from '../../classes/memberUser';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//mui
import GradeIcon from '@mui/icons-material/Grade';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import PollIcon from '@mui/icons-material/Poll';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import BallotIcon from '@mui/icons-material/Ballot';
import PlusOneIcon from '@mui/icons-material/PlusOne';
// import DatabaseRequestController from '../../controllers/DatabaseRequestController';
// import { resolveAny } from 'dns';

class VoteDetail {
    public voter: MemberUser = {} as MemberUser;
    public voteIndex: number = 0;
}

const nonstate = {
    controlledImgSize: 500
}

interface Props {

}

const ViewPolls: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states - vars
    const [page, SetPage] = useState(ViewPolls_PageMap.NEW_POLLS);
    const [newPolls, SetNewPolls] = useState([] as Poll[]);
    const [votedPolls, SetVotedPolls] = useState([] as Poll[]);
    const [selectedPoll, SetSelectedPoll] = useState<Poll>({} as Poll);
    const [countDownTimer, SetCountDownTimer] = useState<number>(0);
    const [filterMode, SetFilterMode] = useState<number>(ViewPolls_filterMode.ALL);
    const [committeeTypeList, SetCommitteeTypeList] = useState<string[]>([] as string[]);
    const [committeeTypeCheckings, SetCommitteeTypeCheckings] = useState<boolean[]>([] as boolean[]);
    const [optionsFilter, SetOptionsFilter] = useState<string[]>([] as string[]); //options index in it will show results in vote-details
    //states - form vars
    const [newLabel, SetNewLabel] = useState<string>('');
    const [newAddOptionValue, SetNewAddOptionValue] = useState<string>('');
    const [newOptions, SetNewOptions] = useState<string[]>([]);
    const [newPollStart, SetNewPollStart] = useState<Date>(new Date());
    const [newPollEnd, SetNewPollEnd] = useState<Date>(new Date());


    //refs - vars
    const pageRef = useRef<number>(page);
    const countDownTimerRef = useRef<number>(0);
    const filterModeRef = useRef<number>(filterMode);
    const uploadOptionsCountRef = useRef<number>(0);
    const optionsFilterRef = useRef<string[]>([] as string[]);
    //refs - formVars
    const newOptionsRef = useRef<string[]>([] as string[]);
    const newAddOptionValueRef = useRef<string>('');
    //refs - intervals
    const countDownIntervalRef = useRef<any>(null);
    //refs - objs
    const canvasRef = useRef<HTMLCanvasElement>();
    const imageRef = useRef(new Image());
    const prevSelectedPollRef = useRef<Poll>(selectedPoll);
    //router objs
    const location = useLocation();
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('VillPollsTest: ' + JSON.stringify(exAppContext.unvotedCurrentAndVotedPolls));
    // }, [exAppContext.unvotedCurrentAndVotedPolls]);

    //initialization
    useEffect(() => {
        // databaseInterfaceController.Queue('fetchOngoingPolls', [
        //     ['fetchOngoingPolls', 'true'],
        //     ['dateNow', IonDateString(new Date())],
        //     ['committee_typeID', appContext.user.committee_typeID]
        // ]); ---deprecated
        databaseInterfaceController.Queue('fetchUnvotedCurrentAndVotedPolls', [
            ['fetchUnvotedCurrentAndVotedPolls', 'true'],
            ['dateNow', IonDateString(new Date())],
            ['committee_typeID', appContext.user.committee_typeID],
            ['userID', appContext.user.userID]
        ]);

        return (() => {
            if (countDownIntervalRef.current != null) {
                clearInterval(countDownIntervalRef.current);
            }
        });
    }, []);

    //watch for unvotedCurrentAndVotedPolls, update newPolls and votedPolls
    useEffect(() => {
        const _votedPolls = [] as Poll[];
        const _newPolls = [] as Poll[];
        exAppContext.unvotedCurrentAndVotedPolls.map((poll: Poll) => {
            if (poll.voterIDs.join(',').includes(appContext.user.userID)) {
                _votedPolls.push(poll);
            } else {
                _newPolls.push(poll);
            }
        });
        SetVotedPolls([..._votedPolls]);
        SetNewPolls([..._newPolls]);
    }, [exAppContext.unvotedCurrentAndVotedPolls]);

    //watch for location pathname auto-navigate to page
    useEffect(() => {
        const pathNameArr = location.pathname.split('/');
        let autoSelectedPoll = {} as Poll;
        if (pathNameArr[2] == 'NewPolls') {
            autoSelectedPoll = GetOngoingByID(pathNameArr[3]);
            if (Object.keys(autoSelectedPoll).length > 0) {
                SetPage(ViewPolls_PageMap.NEW_POLLS);
                setTimeout(() => {
                    OnSelectUnselectPoll(autoSelectedPoll);
                }, 100);
            }
        } else if (pathNameArr[2] == 'HostedPolls') {
            autoSelectedPoll = GetHostedPollByID(pathNameArr[3]);
            if (Object.keys(autoSelectedPoll).length > 0) {
                SetPage(ViewPolls_PageMap.MY_POLLS);
                setTimeout(() => {
                    OnSelectUnselectPoll(autoSelectedPoll);
                }, 100);
            }
        }
    }, [location.pathname]);

    //watch for page update, reset pollSelection, resetForm
    useEffect(() => {

        switch (page) {
            case ViewPolls_PageMap.CREATE_POLL:
            case ViewPolls_PageMap.EDIT_POLL:
            case ViewPolls_PageMap.MY_POLLS:
            case ViewPolls_PageMap.NEW_POLLS:
            case ViewPolls_PageMap.VOTED_POLLS:
                SetSelectedPoll({} as Poll);
                ResetCreatePollForm();
                break;
            case ViewPolls_PageMap.VOTE_DETAILS:
                if (Object.keys(selectedPoll).length > 0) {
                    //initialize options filter
                    optionsFilterRef.current = [] as string[];
                    selectedPoll.options.map((option: string) => {
                        optionsFilterRef.current.push(option);
                    });
                    SetOptionsFilter([...optionsFilterRef.current]);
                }
                break;
        }
    }, [page]);

    //watch for exAppContext committeeTypes update committeeTypeList
    useEffect(() => {
        const _committeeTypeList = [] as string[];
        const _committeeTypeCheckings = [] as boolean[];
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            _committeeTypeList.push(committeeType.label);
            _committeeTypeCheckings.push(false);
        });
        SetCommitteeTypeList([..._committeeTypeList]);
        SetCommitteeTypeCheckings([..._committeeTypeCheckings]);
    }, [exAppContext.committeeTypes]);

    //watch for poll selected, set countdown interval
    useEffect(() => {
        if (Object.keys(selectedPoll).length > 0) {
            const millisNow = new Date().getTime();
            countDownTimerRef.current = (selectedPoll.poll_end != null ? (selectedPoll.poll_end.getTime() - millisNow) : 0);
            countDownIntervalRef.current != null ? clearInterval(countDownIntervalRef.current) : null;
            countDownIntervalRef.current = setInterval(() => {
                if (countDownTimerRef.current - 1000 > 0) {
                    countDownTimerRef.current -= 1000;
                } else {
                    appContext.SetDatabaseShouldShowWaitScreen(false);
                    countDownTimerRef.current = 0;
                    clearInterval(countDownIntervalRef.current);
                    databaseInterfaceController.Queue('fetchUnvotedCurrentAndVotedPolls', [
                        ['fetchUnvotedCurrentAndVotedPolls', 'true'],
                        ['dateNow', IonDateString(new Date())],
                        ['committee_typeID', appContext.user.committee_typeID],
                        ['userID', appContext.user.userID]
                    ]);
                }
                SetCountDownTimer(countDownTimerRef.current);
            }, 1000);
        } else {
            countDownIntervalRef.current != null ? clearInterval(countDownIntervalRef.current) : null;
        }
    }, [selectedPoll]);

    //watch for databaseActionMode & databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'createPoll':
                        if (!JSON.stringify(res).includes('_false')) {
                            //upload options one by one
                            const pollID = res;
                            uploadOptionsCountRef.current = newOptions.length;

                            //upload first option
                            databaseInterfaceController.Queue('uploadPollOption', [
                                ['uploadPollOption', 'true'],
                                ['initiatorID', appContext.user.userID],
                                ['pollID', pollID],
                                ['option', newOptions[newOptions.length - uploadOptionsCountRef.current], false] //3rd option encryption => false
                            ]);
                        } else {
                            console.log('createPollErr: ' + res);
                        }
                        break;
                    case 'uploadPollOption':
                        if (!JSON.stringify(res).includes('_false')) {
                            const pollID = res;

                            if (uploadOptionsCountRef.current > 1) {
                                uploadOptionsCountRef.current -= 1;

                                //upload next option
                                databaseInterfaceController.Queue('uploadPollOption', [
                                    ['uploadPollOption', 'true'],
                                    ['initiatorID', appContext.user.userID],
                                    ['pollID', pollID],
                                    ['option', newOptions[newOptions.length - uploadOptionsCountRef.current], false]
                                ]);
                            } else {
                                //poll creation complete
                                appContext.SetPopupMessage('Poll created successfully');
                                SetPage(ViewPolls_PageMap.MY_POLLS);

                                databaseInterfaceController.Queue('fetchHostedPolls', [
                                    ['fetchHostedPolls', 'true'],
                                    ['hostID', appContext.user.userID]
                                ]);
                            }
                        } else {
                            console.log('uploadPollOption: ' + res);
                        }
                        break;
                    case 'updatePollVotes':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('You have completed the voting!');
                            // databaseInterfaceController.Queue('fetchOngoingPolls', [
                            //     ['fetchOngoingPolls', 'true'],
                            //     ['dateNow', IonDateString(new Date())],
                            //     ['committee_typeID', appContext.user.committee_typeID]
                            // ]); ---deprecated
                            databaseInterfaceController.Queue('fetchUnvotedCurrentAndVotedPolls', [
                                ['fetchUnvotedCurrentAndVotedPolls', 'true'],
                                ['dateNow', IonDateString(new Date())],
                                ['committee_typeID', appContext.user.committee_typeID],
                                ['userID', appContext.user.userID]
                            ]);
                        } else {
                            if (JSON.stringify(res).includes('pollUnfoundErr')) {
                                appContext.SetPopupMessage('Voting failed, the poll has been removed by host.');
                                OnReloadBtnClicked();
                            } else {
                                console.log('updatePollVotesErr: ' + res);
                            }
                        }
                        break;
                    case 'deletePoll':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Successfully deleted a poll');
                            databaseInterfaceController.Queue('fetchHostedPolls', [
                                ['fetchHostedPolls', 'true'],
                                ['hostID', appContext.user.userID]
                            ]);
                        } else {
                            console.log('deletePollErr ' + res);
                        }
                        break;
                }

            }

            switch (appContext.databaseActionModeQueue[0]) {
                // case 'fetchOngoingPolls': --deprecated
                case 'createPoll':
                case 'uploadPollOption':
                case 'updatePollVotes':
                case 'deletePoll':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnSelectPollOption = (poll: Poll, voterID: string, optionIndex: number) => {
        const updatedPoll = poll;
        //remove any existing vote related to voter
        updatedPoll.voterIDs.map((_voterID: string, i: number) => {
            if (_voterID == voterID) {
                updatedPoll.voterIDs.splice(i, 1);
                updatedPoll.votes.splice(i, 1);
            }
        });
        //add new vote of voter
        updatedPoll.voterIDs.push(voterID);
        updatedPoll.votes.push(optionIndex);

        const _newPolls = newPolls;
        const _votedPolls = votedPolls;

        _newPolls.map((_poll: Poll, i: number) => {
            if (_poll.pollID == updatedPoll.pollID)
                _newPolls.splice(i, 1, updatedPoll)
        });
        SetNewPolls([..._newPolls]);

        _votedPolls.map((_poll: Poll, i: number) => {
            if (_poll.pollID == updatedPoll.pollID)
                _votedPolls.splice(i, 1, updatedPoll)
        });
        SetVotedPolls([..._votedPolls]);
    }
    const OnSubmitVoteClicked = (poll: Poll) => {
        if (!IsPollExpired(poll)) {
            if (IsPollVotedByUser(poll, appContext.user.userID)) {
                appContext.SetPopupMessage('Are you sure to vote for this option?');
                appContext.SetPopupButtons(['Yes', 'No']);
                appContext.SetPopupActions([() => {
                    const updatedPoll = poll;

                    //initiate poll votes update to server
                    databaseInterfaceController.Queue('updatePollVotes', [
                        ['updatePollVotes', 'true'],
                        ['initiatorID', appContext.user.userID],
                        ['pollID', updatedPoll.pollID],
                        ['voterIDs', updatedPoll.voterIDs.join(',')],
                        ['votes', updatedPoll.votes.join(',')]
                    ]);

                    //reset selectedPoll
                    prevSelectedPollRef.current = {} as Poll;
                    SetSelectedPoll(prevSelectedPollRef.current);
                }, () => { }]);
            } else {
                appContext.SetPopupMessage('You must select an option to vote');
            }
        } else {
            appContext.SetPopupMessage('The poll has ended,\nno more changes allowed.');
        }
    }
    const OnFilterModeSwitchClicked = () => {
        switch (filterMode) {
            default:
            case 0:
                filterModeRef.current = 1;
                break;
            case 1:
                filterModeRef.current = 2;
                break;
            case 2:
                filterModeRef.current = 3;
                break;
            case 3:
                filterModeRef.current = 0;
                break;
        }
        SetFilterMode(filterModeRef.current);
    }
    const OnBrowseImageClicked = async () => {
        appContext.SetAppStateChangeWatch(false);

        await Camera.pickImages({ limit: 1 }).then((res: any) => {
            const _res = res.photos[0];
            // CropAndResize(_res.webPath ? _res.webPath : ''); ---deprecated to resize
            Resize(_res.webPath ? _res.webPath : '');
        });
    }
    const OnRemoveBrowsedImageClicked = () => {
        newAddOptionValueRef.current = '';
        SetNewAddOptionValue(newAddOptionValueRef.current);
    }
    const OnAddNewOptionClicked = () => {
        if (newAddOptionValueRef.current.length > 0) {
            newOptionsRef.current.push(newAddOptionValueRef.current);
            SetNewOptions([...newOptionsRef.current]);

            newAddOptionValueRef.current = '';
            SetNewAddOptionValue(newAddOptionValueRef.current);
        }
    }
    const OnCreatePollClicked = () => {
        const newViewableCommitteeTypeIDs = [] as string[];
        committeeTypeList.map((committeeTypeLabel: string, i: number) => {
            if (committeeTypeCheckings[i]) {
                newViewableCommitteeTypeIDs.push(GetCommitteeTypeIDByLabel(committeeTypeLabel));
            }
        });

        if (
            newLabel.length > 0
            && newOptions.length >= 2
            && newViewableCommitteeTypeIDs.length > 0
        ) {
            databaseInterfaceController.Queue('createPoll', [
                ['createPoll', 'true'],
                ['initiatorID', appContext.user.userID],
                ['label', newLabel],
                // ['options', newOptions.join(':;:')], //options need to be upload one by one
                ['poll_start', IonDateString(newPollStart)],
                ['poll_end', IonDateString(newPollEnd)],
                ['viewable_committee_typeIDs', newViewableCommitteeTypeIDs.join(',')],
                ['hostID', appContext.user.userID]
            ]);
        } else {
            appContext.SetPopupMessage('Please make sure all (*) marked criterias are met');
        }
    }
    const OnDiscardPollClicked = () => {
        appContext.SetPopupMessage('Are you sure to discard the form ?\nChanges will not be saved.');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            ResetCreatePollForm();
            SetPage(ViewPolls_PageMap.MY_POLLS);
        }, () => { }]);
    }
    const OnRemoveVoteOptionClicked = (option: string) => {
        newOptionsRef.current.map((_option: string, i: number) => {
            if (_option == option)
                newOptionsRef.current.splice(i, 1);
        });
        SetNewOptions([...newOptionsRef.current]);
    }
    const OnSelectUnselectPoll = (poll: Poll) => {
        if (Object.keys(poll).length > 0) {
            //is selecting poll
            prevSelectedPollRef.current = poll;
            SetSelectedPoll(prevSelectedPollRef.current);
        } else {
            //is unselecting poll
            //poll vote not saved, revert the poll back to prevstate
            const _newPolls = newPolls;
            _newPolls.map((_poll: Poll, i: number) => {
                if (_poll.pollID == poll.pollID) {
                    _newPolls.splice(i, 1, prevSelectedPollRef.current);
                    prevSelectedPollRef.current = {} as Poll;
                }
            });

            const _votedPolls = votedPolls;
            _votedPolls.map((_poll: Poll, i: number) => {
                if (_poll.pollID == poll.pollID) {
                    _votedPolls.splice(i, 1, prevSelectedPollRef.current);
                }
            });

            prevSelectedPollRef.current = {} as Poll;
            SetSelectedPoll(prevSelectedPollRef.current);
            SetNewPolls(_newPolls);
            SetVotedPolls(_votedPolls);
        }
    }
    const OnDeletePollClicked = (poll: Poll) => {
        appContext.SetPopupMessage('Are you sure to delete this poll?\nAll vote results will be removed.');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('deletePoll', [
                ['deletePoll', 'true'],
                ['initiatorID', appContext.user.userID],
                ['pollID', poll.pollID],
                ['hostID', appContext.user.userID]
            ]);
        }, () => { }]);
    }
    const OnReloadBtnClicked = () => {
        switch (page) {
            case ViewPolls_PageMap.NEW_POLLS:
            case ViewPolls_PageMap.VOTED_POLLS:
                databaseInterfaceController.Queue('fetchUnvotedCurrentAndVotedPolls', [
                    ['fetchUnvotedCurrentAndVotedPolls', 'true'],
                    ['dateNow', IonDateString(new Date())],
                    ['committee_typeID', appContext.user.committee_typeID],
                    ['userID', appContext.user.userID]
                ]);
                break;
            case ViewPolls_PageMap.MY_POLLS:
                databaseInterfaceController.Queue('fetchHostedPolls', [
                    ['fetchHostedPolls', 'true'],
                    ['hostID', appContext.user.userID]
                ]);
                databaseInterfaceController.Queue('fetchAllCommitteeMembers', [
                    ['fetchAllCommitteeMembers', 'true']
                ]);
                break;
        }
    }
    const OnViewVoteDetailsClicked = () => {
        SetPage(ViewPolls_PageMap.VOTE_DETAILS);
    }
    const OnSelectUnselectOptionFilter = (option: string) => {
        let isInFilter = false;
        optionsFilterRef.current.map((_option: string, i: number) => {
            if (_option == option) {
                isInFilter = true;
                //remove from filter
                optionsFilterRef.current.splice(i, 1);
            }
        });

        if (!isInFilter)
            optionsFilterRef.current.push(option);

        SetOptionsFilter([...optionsFilterRef.current]);
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ViewPolls_PageMap.NEW_POLLS:
                return RenderNewPolls()
            case ViewPolls_PageMap.VOTED_POLLS:
                return RenderVotedPolls()
            case ViewPolls_PageMap.MY_POLLS:
                return RenderHostedPolls()
            case ViewPolls_PageMap.CREATE_POLL:
                return RenderCreateEditPollForm(ViewPolls_createEditPollMode.CREATE);
            case ViewPolls_PageMap.EDIT_POLL:
                return RenderCreateEditPollForm(ViewPolls_createEditPollMode.EDIT);
            case ViewPolls_PageMap.VOTE_DETAILS:
                return RenderVoteDetailsPage();;
        }
    }
    const RenderNewPolls = () => {
        return (
            <div className='page new-polls'>
                {
                    newPolls.length > 0 ?
                        <div className='page-scroll'>
                            {
                                newPolls.map((poll: Poll, i: number) => {
                                    return RenderPollSelectionBlock(poll, i)
                                })
                            }
                        </div>
                        :
                        <span className='no-record-lbl'>No new polls found,<br />come back again later.</span>
                }
            </div>
        )
    }
    const RenderVotedPolls = () => {
        return (
            <div className='page voted-polls'>
                {
                    votedPolls.length > 0 ?
                        <div className='page-scroll'>
                            {
                                votedPolls.map((poll: Poll, i: number) => {
                                    return RenderPollSelectionBlock(poll, i)
                                })
                            }
                        </div>
                        :
                        <span className='no-record-lbl'>No ongoing voted polls found,<br />check again later.</span>
                }
            </div>
        )
    }
    const RenderPollSelectionBlock = (poll: Poll, i: number) => {
        return (
            <div className='poll-selection-block' key={'poll-selection-btn-' + i}>
                <button className='poll-selection-btn' onClick={() => {
                    JSON.stringify(selectedPoll) != JSON.stringify(poll) ?
                        OnSelectUnselectPoll(poll)
                        :
                        OnSelectUnselectPoll({} as Poll)
                }}>
                    <span className='poll-selection-btn-title'>{poll.label}</span>
                    <span className='poll-selection-btn-lbl'>Vote Ends At<br />{IonDateString(poll.poll_end, IonDateFormat.LONG_DATE_TIME)}</span>
                </button>
                {
                    Object.keys(selectedPoll).length > 0 && selectedPoll.pollID == poll.pollID ?
                        RenderSelectedPollMenu(poll)
                        :
                        null
                }
            </div>
        )
    }
    const RenderSelectedPollMenu = (poll: Poll) => {
        return (
            <div className='poll-selection-menu'>
                <div className='poll-selection-row'>
                    {
                        !IsPollExpired(poll) ?
                            <span className='poll-lbl'>{page == ViewPolls_PageMap.NEW_POLLS ? 'Voting' : 'Change Vote'} Ends In {MillisToTime(countDownTimer)}</span>
                            :
                            <span className='poll-lbl'>Poll Has Ended.</span>
                    }
                </div>
                {
                    poll.options.map((option: string, i: number) => {
                        const isOptionSelected = IsPollOptionSelected(poll, appContext.user.userID, i);
                        return (
                            <button disabled={IsPollExpired(poll)} className={'poll-selection-menu-btn ' + (isOptionSelected ? 'selected' : '')} onClick={() => OnSelectPollOption(poll, appContext.user.userID, i)}>
                                {
                                    IsOptionImage(option) ?
                                        <div className='poll-selection-menu-btn-img'>
                                            <ImagePreviewer src={option} />
                                        </div>
                                        :
                                        <span className='poll-selection-menu-btn-lbl'>{option}</span>
                                }
                                <span className='poll-selection-menu-btn-lbl ex'>{GetVoteCountsOfOption(poll.votes, i) + ' votes'}</span>
                            </button>
                        )
                    })
                }
                <div className='poll-selection-row right'>
                    <button className='poll-selection-row-btn' onClick={() => OnSubmitVoteClicked(poll)}>{page == ViewPolls_PageMap.NEW_POLLS ? 'Submit' : 'Change'} Vote</button>
                </div>
            </div>
        );
    }
    const RenderHostedPolls = () => {
        const filteredHostedPolls = FilterPollsByMode(exAppContext.hostedPolls);

        return (
            <div className='page hosted-polls'>
                {
                    filteredHostedPolls.length > 0 ?
                        <div className='page-scroll'>
                            {
                                filteredHostedPolls.map((poll: Poll, i: number) => {
                                    return RenderHostedPollSelectionBlock(poll, i)
                                })
                            }
                        </div>
                        :
                        <span className='no-record-lbl'>No hosted polls found,<br />click create poll to create one now.</span>
                }
                <div className='page-option-panel'>
                    <button className='page-option-btn' onClick={() => OnFilterModeSwitchClicked()}>filter: {CapitalizeInitial(GetObjectKeyByValue(ViewPolls_filterMode, filterMode))}</button>
                    <button className='page-option-btn' onClick={() => SetPage(ViewPolls_PageMap.CREATE_POLL)}><AddIcon /> Create Poll</button>
                </div>
            </div>
        )
    }
    const RenderHostedPollSelectionBlock = (poll: Poll, i: number) => {
        return (
            <div className='poll-selection-block' key={'poll-selection-block-' + i}>
                <button className='poll-selection-btn' onClick={() => { JSON.stringify(selectedPoll) != JSON.stringify(poll) ? SetSelectedPoll(poll) : SetSelectedPoll({} as Poll) }}>
                    <span className='poll-selection-btn-title'>{poll.label}</span>
                    <span className='poll-selection-btn-lbl'>{GetPollStatus(poll)}</span>
                </button>
                {
                    Object.keys(selectedPoll).length > 0 && selectedPoll.pollID == poll.pollID ?
                        RenderPollResultsMenu(poll)
                        :
                        null
                }
            </div>
        )
    }
    const RenderPollResultsMenu = (poll: Poll) => {
        return (
            <div className='poll-results-menu'>
                {
                    poll.options.map((option: string, i: number) => {
                        return (
                            <div className='menu-row'>
                                {
                                    IsOptionImage(option) ?
                                        <div className='menu-row-img'>
                                            <ImagePreviewer src={option} />
                                        </div>
                                        :
                                        <span className='menu-row-title'>{option}</span>
                                }
                                <span className='menu-row-lbl'>{GetVoteStatsOfOption(poll, i)}</span>
                            </div>
                        )
                    })
                }
                <div className='menu-row right'>
                    <button className='menu-row-btn' onClick={() => OnDeletePollClicked(poll)}><DeleteIcon /> Delete Poll</button>
                    <button className='menu-row-btn' onClick={() => OnViewVoteDetailsClicked()}><BallotIcon />Vote Details</button>
                </div>
            </div>
        );
    }
    const RenderCreateEditPollForm = (mode: number) => {
        switch (mode) {
            case ViewPolls_createEditPollMode.CREATE:
                break;
            case ViewPolls_createEditPollMode.EDIT:
                break;
        }

        const isNewAddOptionValueImage = IsOptionImage(newAddOptionValue);

        return (
            <Fragment>
                <div className='bg-mask' />
                <div className='form'>
                    <div className='form-menu'>
                        <span className='form-title'>{page == ViewPolls_PageMap.CREATE_POLL ? 'Create New Poll' : 'Edit Poll'}</span>
                        <span className='form-subtitle'>(*) marked cannot be left empty</span>
                        <div className='form-col'>
                            <span className='form-lbl'>Subject (*)</span>
                            <input className='form-in' value={newLabel} onChange={(e: any) => SetNewLabel(e.target.value)} />
                        </div>
                        <div className='form-col'>
                            <span className='form-lbl'>Vote Options (* at least two options)</span>
                            <div className='form-scroll'>
                                {
                                    newOptions.map((option: string) => {
                                        return (
                                            <div className='form-scroll-row'>
                                                {
                                                    IsOptionImage(option) ?
                                                        <div className='form-scroll-img'>
                                                            <ImagePreviewer src={option} />
                                                        </div>
                                                        :
                                                        <span className='form-scroll-lbl'>{option}</span>
                                                }
                                                <button className='form-scroll-btn' onClick={() => OnRemoveVoteOptionClicked(option)}><RemoveCircleIcon /></button>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='vote-option-block'>
                                {
                                    isNewAddOptionValueImage ?
                                        <div className='form-img'>
                                            <ImagePreviewer src={newAddOptionValue} />
                                        </div>
                                        :
                                        <textarea className='form-text' onChange={(e: any) => { newAddOptionValueRef.current = e.target.value; SetNewAddOptionValue(newAddOptionValueRef.current) }} placeholder={'type in option to add'} value={newAddOptionValue}></textarea>
                                }
                                <div className='vote-option-row'>
                                    <button className={'form-btn ex'} onClick={() => { isNewAddOptionValueImage ? OnRemoveBrowsedImageClicked() : OnBrowseImageClicked() }}>{isNewAddOptionValueImage ? 'Remove Image' : 'Select Image'}</button>
                                    <button className='form-btn' onClick={() => OnAddNewOptionClicked()}>Add New Option</button>
                                </div>
                            </div>
                        </div>
                        <div className='form-col'>
                            <span className='form-lbl'>Voting Starts At</span>
                            <div className='form-datetime-picker'>
                                <DateTimePicker dateTime={newPollStart} SetDateTime={SetNewPollStart} />
                            </div>
                        </div>
                        <div className='form-col'>
                            <span className='form-lbl'>Voiting Ends On</span>
                            <div className='form-datetime-picker'>
                                <DateTimePicker dateTime={newPollEnd} SetDateTime={SetNewPollEnd} />
                            </div>
                        </div>
                        <div className='form-col'>
                            <span className='form-lbl'>Poll Available To (* at least one selected)</span>
                            <div className='form-select-checker'>
                                <SelectionChecker checkList={committeeTypeList} checkings={committeeTypeCheckings} SetCheckings={SetCommitteeTypeCheckings} placeholder='Select Committee Type' />
                            </div>
                        </div>

                        <div className='form-option-panel'>
                            <button className='form-option-btn' onClick={() => OnCreatePollClicked()}>{mode == ViewPolls_createEditPollMode.CREATE ? 'Create' : 'Update'}</button>
                            <button className='form-option-btn' onClick={() => OnDiscardPollClicked()}>Discard</button>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
    const RenderVoteDetailsPage = () => {
        return (
            <div className='page vote-details'>
                <span className='page-title'>Subject: {selectedPoll.label}</span>
                <div className='page-row'>
                    <div className='options-scroll-panel'>
                        {
                            selectedPoll.options.map((option: string, i: number) => {
                                if (IsOptionImage(option)) {
                                    return (
                                        <button className={'options-scroll-btn ' + (IsOptionInFilter(option) ? 'selected' : '')} onClick={() => OnSelectUnselectOptionFilter(option)}>
                                            <span className='options-scroll-count'>{(i + 1).toString()}</span>
                                            <img className={'options-scroll-img'} src={option} />
                                        </button>
                                    )
                                } else {
                                    return (
                                        <button className={'options-scroll-btn ' + (IsOptionInFilter(option) ? 'selected' : '')} onClick={() => OnSelectUnselectOptionFilter(option)}>
                                            <span className='options-scroll-count'>{(i + 1).toString()}</span>
                                            <span className={'options-scroll-lbl'}>{option}</span>
                                        </button>
                                    )
                                }
                            })
                        }
                    </div>
                    <div className='vote-details-panel'>
                        {
                            FilterVoteDetails(selectedPoll).map((voteDetail: VoteDetail) => {
                                return (
                                    <div className='vote-details-row'>
                                        <div className='vote-details-col'>
                                            <span className='vote-details-lbl'>{voteDetail.voter.name}</span>
                                            <span className='vote-details-lbl ex'>{voteDetail.voter.email}</span>
                                        </div>
                                        <div className='vote-details-col'>
                                            <span className='vote-details-vote-lbl'>{voteDetail.voteIndex}</span>
                                            <PlusOneIcon />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='page-option-panel'>
                    <button className='page-option-btn' onClick={() => { SetPage(ViewPolls_PageMap.MY_POLLS) }}>Back</button>
                </div>
            </div>
        );
    }

    //exe functions
    const MillisToTime = (millis: number) => {
        const total_seconds = parseInt((millis / 1000).toString());
        const total_minutes = parseInt((total_seconds / 60).toString());
        const total_hours = parseInt((total_minutes / 60).toString());
        const remainding_minutes = total_minutes - (total_hours * 60);
        const remainding_seconds = total_seconds - (total_minutes * 60);

        return total_hours.toString().padStart(4, '0') + ' : ' + remainding_minutes.toString().padStart(2, '0') + ' : ' + remainding_seconds.toString().padStart(2, '0');
    }
    const GetPollStatus = (poll: Poll) => {
        const dateNow = new Date();
        if (poll.poll_start != null && dateNow < poll.poll_start)
            return 'Scheduled';
        else if (
            (poll.poll_start != null && poll.poll_end != null)
            && (dateNow >= poll.poll_start && dateNow <= poll.poll_end)
        ) {
            return 'Ongoing | ' + CalculatePollVotedStat(poll) + ' voted';;
        } else if (poll.poll_end != null && dateNow > poll.poll_end) {
            return 'Ended | ' + CalculatePollVotedStat(poll) + ' voted';
        }
    }
    const GetObjectKeyByValue = (object: any, value: any) => {
        let res = '';
        Object.keys(object).map((key) => {
            if (object[key] == value)
                res = key;
        });
        return res;
    }
    const GetCommitteeTypeIDByLabel = (label: string) => {
        let res = '';
        exAppContext.committeeTypes.map((type: CommitteeType) => {
            if (type.label == label)
                res = type.committee_typeID;
        });
        return res;
    }
    // const CropAndResize = (imgUrl: string) => {
    //     canvasRef.current = document.createElement('canvas');
    //     canvasRef.current.width = nonstate.controlledImgSize; canvasRef.current.height = nonstate.controlledImgSize;
    //     const context = canvasRef.current.getContext('2d');

    //     //process image
    //     if (imgUrl != '') {
    //         imageRef.current.src = imgUrl;
    //         imageRef.current.onload = () => {
    //             //get image profile
    //             let [orientation, grabSize, offset] = GetImageProfile(imageRef.current);

    //             if (context) {
    //                 context.drawImage(
    //                     imageRef.current,
    //                     orientation == 'portrait' ? 0 : offset, //grab ori image pos X
    //                     orientation == 'landscape' ? 0 : offset,//grab ori image pos Y
    //                     grabSize, grabSize,
    //                     0, 0, //start draw from canvas pos 
    //                     nonstate.controlledImgSize, nonstate.controlledImgSize //draw till canvas dimension);
    //                 );
    //                 if (canvasRef.current) {
    //                     const imgBase64String = canvasRef.current.toDataURL();
    //                     newAddOptionValueRef.current = imgBase64String;
    //                     SetNewAddOptionValue(newAddOptionValueRef.current);
    //                 }
    //             }
    //         }
    //     }
    // } ---deprecated to resize
    const Resize = (imgUrl: string) => {
        canvasRef.current = document.createElement('canvas');
        const context = canvasRef.current.getContext('2d');

        //process image
        if (imgUrl != '') {
            imageRef.current.src = imgUrl;
            imageRef.current.onload = () => {
                //get image profile
                let [orientation, img_width, img_height] = GetImageProfile(imageRef.current);
                const w_h_ratio = img_width / img_height;
                const shouldDrawTillXPos = (orientation == 'portrait' ? nonstate.controlledImgSize : w_h_ratio * nonstate.controlledImgSize);
                const shouldDrawTillYPos = (orientation == 'landscape' ? nonstate.controlledImgSize : nonstate.controlledImgSize / w_h_ratio);

                if (canvasRef.current != undefined) {
                    canvasRef.current.width = shouldDrawTillXPos;
                    canvasRef.current.height = shouldDrawTillYPos;
                }

                if (context) {
                    context.drawImage(
                        imageRef.current,
                        // orientation == 'portrait' ? 0 : offset, //grab ori image pos X
                        // orientation == 'landscape' ? 0 : offset,//grab ori image pos Y
                        0, 0,
                        img_width, img_height,
                        0, 0, //start draw from canvas pos 
                        shouldDrawTillXPos, shouldDrawTillYPos //draw till canvas dimension
                    );
                    if (canvasRef.current) {
                        const imgBase64String = canvasRef.current.toDataURL();
                        newAddOptionValueRef.current = imgBase64String;
                        SetNewAddOptionValue(newAddOptionValueRef.current);
                    }
                }
            }
        }
    }
    const GetImageProfile = (image: HTMLImageElement): [string, number, number] => {

        let orientation: string = '';
        let img_width: number = 0;
        let img_height: number = 0;
        let grabSize: number = 0;
        let grabOffset: number = 0;

        if (image.height >= image.width) {
            //is a portrait or square
            orientation = 'portrait';
            grabSize = image.width;
            grabOffset = (image.height - image.width) / 2;
        } else {
            //is a landscape
            orientation = 'landscape';
            grabSize = image.height;
            grabOffset = (image.width - image.height) / 2;
        }
        img_width = image.width; img_height = image.height;

        return [orientation, img_width, img_height];
    }
    const ResetCreatePollForm = () => {
        SetNewLabel('');

        newOptionsRef.current = [] as string[];
        SetNewOptions(newOptionsRef.current);

        newAddOptionValueRef.current = '';
        SetNewAddOptionValue(newAddOptionValueRef.current);

        SetNewOptions([] as string[]);
        SetNewPollStart(new Date());
        SetNewPollEnd(new Date());
    }
    const CapitalizeInitial = (subject: string) => {
        let res = subject.toLowerCase();
        res = res.substring(0, 1).toUpperCase() + res.substring(1, res.length);
        return res;
    }
    const CalculatePollVotedStat = (poll: Poll) => {
        let totalCommitteeMember = 0;
        exAppContext.allCommitteeMembers.map((memberUser: MemberUser) => {
            if (poll.viewable_committee_typeIDs.join(',').includes(memberUser.committee_typeID))
                totalCommitteeMember += 1;
        });
        const totalVoted = poll.voterIDs.length;
        return (totalVoted / totalCommitteeMember * 100).toFixed(0) + '%';
    }
    const GetVoteStatsOfOption = (poll: Poll, optionIndex: number) => {
        let totalVotesOfOption = 0;
        const totalVotes = poll.votes.length;
        poll.votes.map((votedOptionIndex: number) => {
            if (votedOptionIndex == optionIndex)
                totalVotesOfOption += 1;
        });
        const votesPercentile = totalVotes > 0 ? (totalVotesOfOption / totalVotes * 100).toFixed(0) : '0';

        return totalVotesOfOption.toString() + ' votes' + '\n' + votesPercentile + '% out of ' + totalVotes + ' votes.';
    }
    const GetOngoingByID = (pollID: string) => {
        let res = {} as Poll;
        exAppContext.unvotedCurrentAndVotedPolls.map((poll: Poll) => {
            if (poll.pollID == pollID)
                res = poll;
        });
        return res;
    }
    const GetHostedPollByID = (pollID: string) => {
        let res = {} as Poll;
        exAppContext.hostedPolls.map((poll: Poll) => {
            if (poll.pollID == pollID)
                res = poll;
        });
        return res;
    }
    const GetCommitteeByID = (userID: string) => {
        let res = {} as MemberUser;
        exAppContext.allCommitteeMembers.map((member: MemberUser) => {
            if (member.userID == userID)
                res = member;
        });
        return res;
    }
    const FilterVoteDetails = (poll: Poll): VoteDetail[] => {
        const filtered = [] as VoteDetail[];
        const votes = poll.votes;
        const voterIDs = poll.voterIDs;

        votes.map((vote: number, i: number) => {
            if (IsOptionInFilter(poll.options[vote])) {
                filtered.push({ voter: GetCommitteeByID(voterIDs[i]), voteIndex: (vote + 1) } as VoteDetail);
            }
        });

        return filtered;
    }
    const FilterPollsByMode = (polls: Poll[]) => {
        const res = [] as Poll[];
        const dateNow = new Date();
        polls.map((poll: Poll) => {
            switch (filterMode) {
                case ViewPolls_filterMode.SCHEDULED:
                    if (poll.poll_start != null && dateNow < poll.poll_start)
                        res.push(poll);
                    break;
                case ViewPolls_filterMode.ONGOING:
                    if (
                        (poll.poll_start != null && dateNow >= poll.poll_start)
                        && (poll.poll_end != null && dateNow < poll.poll_end)
                    )
                        res.push(poll);
                    break;
                case ViewPolls_filterMode.ENDED:
                    if (poll.poll_end != null && dateNow >= poll.poll_end)
                        res.push(poll);
                    break;
                default:
                    res.push(poll);
                    break;
            }
        });
        return res;
    }
    const GetVoteCountsOfOption = (votes: number[], index: number) => {
        let res = 0;
        votes.map((vote: number) => {
            if (vote == index)
                res += 1;
        });
        return res;
    }

    //check functions
    const IsPollOptionSelected = (poll: Poll, userID: string, optionIndex: number) => {
        let isOptionSelected = false;
        poll.voterIDs.map((_voterID: string, i: number) => {
            if (_voterID == userID && poll.votes[i] == optionIndex)
                isOptionSelected = true;
        });
        return isOptionSelected;
    }
    const IsOptionImage = (option: string) => {
        if (option.match(/(.gif|.jpg|.jpeg|.jfif|.pjpeg|.pjp|.png|.svg)/g)) {
            return true;
        } else if (option.includes('data:image/') && option.includes('base64,')) {
            return true;
        } else
            return false;
    }
    const IsPollExpired = (poll: Poll) => {
        const dateNow = new Date();
        if (poll.poll_end != null && dateNow > poll.poll_end)
            return true;
        else
            return false;
    }
    const IsPollVotedByUser = (poll: Poll, shouldVoterID: string) => {
        let res = false;
        poll.voterIDs.map((voterID: string) => {
            if (voterID == shouldVoterID)
                res = true;
        });
        return res;
    }
    const IsOptionInFilter = (option: string) => {
        let res = false;
        optionsFilterRef.current.map((_option: string) => {
            if (option == _option) {
                res = true;
            }
        });
        return res;
    }
    const IsSecretariat = () => {
        let res = false;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (
                committeeType.label.toLowerCase() == 'secretariat'
                && appContext.user.committee_typeID == committeeType.committee_typeID
            )
                res = true;
        });
        return res;
    }

    return (
        <div className='ViewPolls'>
            <div className='option-panel'>
                <button className={'option-btn left ' + (page == ViewPolls_PageMap.NEW_POLLS ? 'selected' : '')} onClick={() => { pageRef.current = ViewPolls_PageMap.NEW_POLLS; SetPage(pageRef.current); }}>
                    {
                        page == ViewPolls_PageMap.NEW_POLLS ? 'New Polls' : ''
                    }
                    <GradeIcon />
                </button>
                <button className={'option-btn ' + (page == ViewPolls_PageMap.VOTED_POLLS ? 'selected' : '')} onClick={() => { pageRef.current = ViewPolls_PageMap.VOTED_POLLS; SetPage(pageRef.current); }}>
                    {
                        page == ViewPolls_PageMap.VOTED_POLLS ? 'Voted Polls' : ''
                    }
                    <HowToVoteIcon />
                </button>
                {
                    IsSecretariat() ?
                        <button className={'option-btn ' + ((page == ViewPolls_PageMap.MY_POLLS || page == ViewPolls_PageMap.VOTE_DETAILS) ? 'selected' : '')} onClick={() => { pageRef.current = ViewPolls_PageMap.MY_POLLS; SetPage(pageRef.current); }}>
                            {
                                (page == ViewPolls_PageMap.MY_POLLS || page == ViewPolls_PageMap.VOTE_DETAILS) ? 'My Polls' : ''
                            }
                            <PollIcon />
                        </button>
                        :
                        null
                }
            </div>
            {RenderPage()}
            {
                (
                    page == ViewPolls_PageMap.NEW_POLLS
                    || page == ViewPolls_PageMap.VOTED_POLLS
                    || page == ViewPolls_PageMap.MY_POLLS
                ) ?
                    <button className='reload-btn' onClick={() => OnReloadBtnClicked()}><RefreshIcon />Reload</button>
                    :
                    null
            }
        </div>
    );
}
export default ViewPolls;